import React from 'react';
import { Check, CloudOff, Loader2, RotateCcw } from 'lucide-react';

const LABEL = {
  saving: { text: 'Saving…', Icon: Loader2, cls: 'text-[#A3A3A3]', spin: true },
  saved: { text: 'Saved', Icon: Check, cls: 'text-emerald-400' },
  offline: { text: 'Saved on this device — will sync', Icon: CloudOff, cls: 'text-amber-300' },
};

// Subtle autosave indicator + "Draft restored" notice with an explicit Discard Draft action.
export const DraftStatus = ({ status, restoredAt, onDiscard, testIdPrefix = 'draft' }) => {
  const s = LABEL[status];
  if (!s && !restoredAt) return null;
  return (
    <div className="mt-2 flex items-center justify-between gap-2 flex-wrap text-[11px]" data-testid={`${testIdPrefix}-status-bar`}>
      {restoredAt ? (
        <span data-testid={`${testIdPrefix}-restored`} className="inline-flex items-center gap-1 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2 py-0.5 text-emerald-200">
          <RotateCcw className="w-3 h-3" /> Draft restored
          <span className="text-emerald-300/70">· {new Date(restoredAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}</span>
        </span>
      ) : <span />}
      <div className="flex items-center gap-3">
        {s && (
          <span data-testid={`${testIdPrefix}-save-state`} data-state={status} className={`inline-flex items-center gap-1 ${s.cls}`}>
            <s.Icon className={`w-3 h-3 ${s.spin ? 'animate-spin' : ''}`} /> {s.text}
          </span>
        )}
        {(restoredAt || status !== 'idle') && onDiscard && (
          <button type="button" data-testid={`${testIdPrefix}-discard`} onClick={onDiscard}
            className="underline text-[#A3A3A3] hover:text-red-300 transition-colors">
            Discard Draft
          </button>
        )}
      </div>
    </div>
  );
};

export default DraftStatus;
